import {components} from "react-select";

const CheckboxOption = (props) => {
	const {isSelected, label} = props;

	return (
		<components.Option {...props}>
			<div className="d-flex align-items-center gap-2">
				<input
					type="checkbox"
					className="form-check-input"
					checked={isSelected}
					readOnly
					tabIndex={-1}
					onChange={() => null}
					aria-hidden="true"
				/>
				<span>{label}</span>
			</div>
		</components.Option>
	);
};

export default CheckboxOption;
